import { filterNonFieldErrors } from '../../utils/errors'

import v1receiveErrors from '../../actions/errors/v1receiveErrors'
import { V1_REQUEST_COMPLETED } from '../../actions/requests/v1requestCompleted'

export default store => next => async action => {
  next(action)

  if (action.type !== V1_REQUEST_COMPLETED) return

  const errors = (action.data || {}).errors || []
  const blockingErrors = filterNonFieldErrors(errors)

  if (blockingErrors.length) store.dispatch(v1receiveErrors(blockingErrors))
}
